import Phaser from "phaser";
import bg from "@/assets/game/office.webp";
import hero from "@/assets/game/man.png";

export default class TitleScene extends Phaser.Scene {
  constructor() {
    super("TitleScene");
  }

  preload() {
    this.load.image("bg", bg);
    this.load.image("char", hero);
  }

  create() {
    // 背景
    this.add.image(400, 300, "bg");

    // 暗化オーバーレイ
    this.overlay = this.add
      .rectangle(400, 300, 800, 600, 0x000000, 0.55)
      .setDepth(1);

    // タイトル文字
    this.titleText = this.add
      .text(400, 120, "情報セキュリティ入門クイズ", {
        fontFamily: "'Noto Sans JP', sans-serif",
        fontSize: "40px",
        fontStyle: "bold",
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 4,
        align: "center",
      })
      .setOrigin(0.5)
      .setDepth(2);

    // 案内文（追加）
    const introText =
      "近年、サイバー攻撃はますます巧妙化・激化し、社会全体の大きな問題となっています。\n" +
      "被害は企業や組織だけでなく、私たち一人ひとりにも及ぶ可能性があります。\n" +
      "こうしたリスクから自分や組織を守るためには、正しい知識と日々の実践が欠かせません。\n" +
      "サイバー攻撃から身を守るために大切な5つのポイントがあります。\n" +
      "このクイズでは、その5つの重要なポイントについて、どの程度ご存じかを確認します。\n" +
      "内容は難しくありませんので、今の知識や感覚で気軽にお答えください。";

    this.introText = this.add
      .text(400, 180, introText, {
        fontFamily: "'Noto Sans JP', sans-serif",
        fontSize: "20px",
        color: "#ffffff",
        align: "left",
        wordWrap: { width: 700, useAdvancedWrap: true },
        lineSpacing: 8, // ← 行間を少し広げる
      })
      .setOrigin(0.5, 0) // 中央寄せ・上揃え
      .setDepth(2);

    // スタートボタン
    const btnWidth = 220;
    const btnHeight = 60;
    const btnX = 400;
    const btnY = 530;

    this.buttonBg = this.add
      .rectangle(btnX, btnY, btnWidth, btnHeight, 0x00b8a9, 1)
      .setStrokeStyle(2, 0xffffff)
      .setDepth(2)
      .setInteractive({ useHandCursor: true });

    this.buttonText = this.add
      .text(btnX, btnY, "スタート", {
        fontFamily: "'Noto Sans JP', sans-serif",
        fontSize: "24px",
        color: "#ffffff",
      })
      .setOrigin(0.5)
      .setDepth(3);

    this.buttonBg.on("pointerover", () => {
      this.buttonBg.setFillStyle(0x00d4c0, 1);
    });
    this.buttonBg.on("pointerout", () => {
      this.buttonBg.setFillStyle(0x00b8a9, 1);
    });
    this.buttonBg.on("pointerdown", () => this.startIntro());

    // カメラフェードイン
    this.cameras.main.fadeIn(800, 0, 0, 0);
  }

  startIntro() {
    // タイトルとボタンをフェードアウト
    this.tweens.add({
      targets: [this.titleText, this.introText, this.buttonBg, this.buttonText],
      alpha: 0,
      duration: 500,
      ease: "Power2",
      onComplete: () => {
        // 背景暗化解除（明るくする）
        this.tweens.add({
          targets: this.overlay,
          alpha: 0,
          duration: 800,
          ease: "Sine.easeInOut",
          onComplete: () => this.showBossIntro(),
        });
      },
    });
  }

  showBossIntro() {
    // 上司のイラスト
    this.boss = this.add.image(400, 400, "char").setScale(0.3).setAlpha(0);

    // テキストウインドウ
    this.textBox = this.add
      .rectangle(400, 490, 760, 200, 0x000000, 0.6)
      .setStrokeStyle(2, 0xffffff)
      .setAlpha(0);

    this.text = this.add
      .text(40, 410, "お、ちょうどいいところに来たな。", {
        fontFamily: "'Noto Sans JP', sans-serif",
        fontSize: "20px",
        color: "#ffffff",
        wordWrap: { width: 730, useAdvancedWrap: true },
        lineSpacing: 8,
        padding: { top: 4 },
      })
      .setAlpha(0);

    this.nextIndicator = this.add
      .text(700, 550, "▶", { fontSize: "20px", color: "#cccccc" })
      .setAlpha(0);

    this.tweens.add({
      targets: this.nextText,
      alpha: { from: 1, to: 0 },
      ease: "Linear",
      duration: 800,
      repeat: -1,
      yoyo: true,
    });

    // フェードインアニメーション
    this.tweens.add({
      targets: [this.boss, this.textBox, this.text],
      alpha: 1,
      duration: 1000,
      delay: 200,
      ease: "Sine.easeInOut",
      onComplete: () => {
        this.showClickIndicator();
      },
    });

    // クリックで本編へ
    this.input.once("pointerdown", () => {
      this.scene.start("NovelScene");
    });
  }

  showClickIndicator() {
    this.tweens.add({
      targets: this.nextIndicator,
      alpha: { from: 0, to: 1 },
      duration: 800,
      yoyo: true,
      repeat: -1,
    });
  }
}
